import { render, staticRenderFns } from "./taskCar.vue?vue&type=template&id=53c2b174&scoped=true"
import script from "./taskCar.vue?vue&type=script&lang=js"
export * from "./taskCar.vue?vue&type=script&lang=js"
import style0 from "./taskCar.vue?vue&type=style&index=0&id=53c2b174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c2b174",
  null
  
)

export default component.exports